import { segment, track } from '@mc/track-event'

export const trackJoinEmailClick = (slug: string) =>
  track(segment.EventTypes.COURSE_MARKETING_CLICK, {
    category: 'hero',
    location: 'hero',
    action: 'Join Waitlist',
    page_type: 'class-page',
    class_type: 'camp',
    class: slug,
    instructor_coming_soon: true,
  })

export const trackComingSoonPurchaseClick = (slug: string, href: string) =>
  track(segment.EventTypes.PURCHASE_CLICK, {
    category: 'hero',
    location: 'hero',
    action: 'waitlist',
    href,
    page_type: 'class-page',
    class_type: 'camp',
    class: slug,
    instructor_coming_soon: true,
  })
